import { fetchMarketplaceSearchSuggestions } from "@/api/services/marketplace";
import {
  mapSearchSuggestionsResponse,
  marketplaceKeys,
} from "@/lib/marketplace";
import type { MarketplaceSearchResult } from "@/types/api/marketplace";
import { useQuery } from "@tanstack/react-query";

export const useMarketplaceSearchSuggestionsData = (
  searchQuery: string,
  enabled = true
) => {
  const trimmed = searchQuery.trim();

  return useQuery({
    queryKey: marketplaceKeys.searchSuggestions(trimmed),
    queryFn: () => fetchMarketplaceSearchSuggestions(trimmed),
    select: (response): MarketplaceSearchResult[] =>
      mapSearchSuggestionsResponse(response),
    enabled,
    staleTime: 30_000,
  });
};
